
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import MaintenanceMode from './components/feature/MaintenanceMode';

function AppRoutes() {
  return useRoutes(routes);
}

function App() {
  // 维护模式状态控制
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      {/* 维护模式覆盖层 */}
      <MaintenanceMode 
        isActive={isMaintenanceMode} 
        onToggle={setIsMaintenanceMode} 
      />
      
      {/* 正常网站内容 */}
      <div className={isMaintenanceMode ? 'hidden' : ''}>
        <AppRoutes />
      </div>

      {/* 管理员快速控制按钮（可选） */}
      {!isMaintenanceMode && (
        <div className="fixed bottom-4 right-4 z-40">
          <button
            onClick={() => setIsMaintenanceMode(true)}
            className="bg-orange-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-orange-700 transition-colors text-sm cursor-pointer"
            title="启用维护模式"
          >
            <i className="ri-tools-line mr-2"></i>
            维护模式
          </button>
        </div>
      )}
    </BrowserRouter>
  );
}

export default App;
